import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Input, Select } from "antd";
import { observer } from "mobx-react";
import { useAffiliateLanguage } from "../../../../../../hooks/useAffiliateLanguage.js";
import { useStores } from "../../../../../../store/stores.js";
import { __, _i } from "../../../../../../utils/i18n.js";
import { MATOMO_MASK } from "../../../../../../utils/matomoMask.js";
import { AffiliatePanel } from "../affiliatePanel.js";
const AffiliateGeneralFields = observer(({ isEdit })=>{
    const languages = useAffiliateLanguage();
    const { accountV2Store: { session, isBusyAffiliateProducts, affiliateProducts } } = useStores();
    const isLoggedIn = !!session?.isLoggedIn;
    return /*#__PURE__*/ _jsxs(AffiliatePanel, {
        heading: __("General"),
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: [
                    "user",
                    "email"
                ],
                label: isLoggedIn ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        __("Email address"),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "rc-account-v2-label-hint",
                            children: [
                                "\xb7 ",
                                __("taken from your account")
                            ]
                        })
                    ]
                }) : __("Email address"),
                rules: [
                    {
                        type: "email",
                        required: true,
                        message: __("Please enter a valid email address!")
                    }
                ],
                required: true,
                extra: isEdit ? _i(__("To change it, edit your {{a}}account details{{/a}}."), {
                    a: /*#__PURE__*/ _jsx("a", {
                        href: "#/details",
                        target: "_blank",
                        rel: "noreferrer"
                    })
                }) : undefined,
                children: /*#__PURE__*/ _jsx(Input, {
                    disabled: isLoggedIn,
                    ...MATOMO_MASK
                })
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                label: __("Preferred language"),
                extra: __("So we can reach you in your preferred language."),
                required: true,
                name: [
                    "affiliate",
                    "communicationLanguage"
                ],
                rules: [
                    {
                        required: true,
                        message: __("Please choose one option!")
                    }
                ],
                children: /*#__PURE__*/ _jsx(Select, {
                    children: Object.keys(languages).map((key)=>/*#__PURE__*/ _jsx(Select.Option, {
                            value: languages[key]["value"],
                            children: languages[key]["localized"]
                        }, key))
                })
            }),
            isEdit ? /*#__PURE__*/ _jsx(Form.Item, {
                label: __("Payout threshold"),
                extra: __("We pay out once your balance passes this amount; otherwise it rolls over to next month."),
                required: true,
                name: [
                    "affiliate",
                    "payoutThreshold"
                ],
                rules: [
                    {
                        required: true,
                        message: __("Please fill in your payout threshold!")
                    }
                ],
                children: /*#__PURE__*/ _jsx(Input, {
                    type: "number",
                    style: {
                        maxWidth: 150
                    },
                    suffix: "EUR"
                })
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        label: __("Products you want to promote"),
                        extra: __("You can still generate links for any product later."),
                        required: true,
                        name: [
                            "interestedInProducts"
                        ],
                        rules: [
                            {
                                required: true,
                                message: __("Please choose at least one product!")
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(Select, {
                            mode: "multiple",
                            loading: isBusyAffiliateProducts,
                            showSearch: true,
                            optionFilterProp: "children",
                            children: affiliateProducts.map(({ id, name })=>/*#__PURE__*/ _jsx(Select.Option, {
                                    value: id,
                                    children: name
                                }, id))
                        })
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        label: __("Promotion strategy"),
                        extra: __("Where and how will you promote us? More detail helps us help you earn more."),
                        required: true,
                        name: [
                            "affiliate",
                            "descriptionOfAdvertisingActions"
                        ],
                        rules: [
                            {
                                required: true,
                                message: __("Please tell us your plans!")
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(Input.TextArea, {
                            className: "rc-account-v2-affiliate-strategy",
                            rows: 4,
                            placeholder: __("I want to write a review about Real Cookie Banner on my-blog.com."),
                            ...MATOMO_MASK
                        })
                    })
                ]
            })
        ]
    });
});
export { AffiliateGeneralFields };
